export const CustomNotificationChanelEnum = {
  BLOG_NOTIFICATIONS: 'blog_notifications',
  INSTALL_APP: 'install_app',
} as const;

export type CustomNotificationChanelType = typeof CustomNotificationChanelEnum[keyof typeof CustomNotificationChanelEnum];
